































































































































































































































































































import { Component, Watch, namespace, mixins } from 'nuxt-property-decorator'
import { NavigationGuardNext, Route } from 'vue-router'
import LazyHydrate from 'vue-lazy-hydration'
import { NuxtAppOptions } from '@nuxt/types'
import { apiError } from '~/assets/functions/api-error'
import { CATALOG_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import { IBanner } from '~/assets/interfaces/banners'
import { componentNameProducts } from '~/assets/functions/products'
import { declension } from '~/assets/functions/declension'
import ComponentCategoryPath from '~/components/navigation/category-path.vue'
import MixinCatalogScrollRestore from '~/assets/mixins/catalog-scroll-restore'
import {
  ICatalogPopularSearches,
  ICatalogSections,
  normalizeCatalogResponse,
} from '~/assets/functions/catalog-response'
import { filterUrl } from '~/assets/filters/url'
import { ICatalogFilterItem } from '~/assets/interfaces/catalog'
import ComponentPageContent from '~/components/pages/content.vue'

const pageStore = namespace('page')
const siteStore = namespace('site')

@Component({
  // watchQuery: true,
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentAlert: () => import('~/components/alerts/alert.vue'),
    ComponentNavigationBreadcrumbs: () =>
      import('~/components/navigation/breadcrumbs.vue'),
    ComponentTypographyH1: () => import('~/components/typography/h1.vue'),
    ComponentPageContent,
    ComponentSeoFilters: () =>
      import('~/components/navigation/seo-filters.vue'),
    ComponentCatalogSorting: () => import('~/components/catalog/sorting.vue'),
    ComponentProductItem1: () =>
      import('~/components/products/product-item-1.vue'),
    ComponentHeaderWithLink: () =>
      import('~/components/header/header-with-link.vue'),
    ComponentIntersect: () => import('~/components/intersect/intersect.vue'),
    ComponentProductItem3: () =>
      import('~/components/products/product-item-3.vue'),
    ComponentMobileProductItem3: () =>
      import('~/components/mobile/products/m-product-item-3.vue'),
    ComponentNavigationPagination: () =>
      import('~/components/navigation/pagination.vue'),
    ComponentBannerStandard: () =>
      import('~/components/banners/banner-standard.vue'),
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
    // Статически: асинхронный компонент в именованном слоте (prepend у
    // фильтра) при SSR попадает в слот по умолчанию — у placeholder'а нет
    // context, и resolveSlots его не относит к prepend. Блок категорий
    // не рендерился на сервере, а на клиенте появлялся → сбой гидрации.
    ComponentCategoryPath,
    ComponentMobileCategoryPath: () =>
      import('~/components/mobile/navigation/m-category-path.vue'),
    ComponentCatalogFilter: () =>
      import('~/components/catalog/filter/catalog-filter.vue'),
    ComponentMobileCatalogFilter: () =>
      import('~/components/mobile/catalog/filter/m-catalog-filter.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
    ComponentCatalogFilterReset: () =>
      import('~/components/catalog/filter/catalog-filter-reset.vue'),
    ComponentCatalogFilterType2: () =>
      import('~/components/catalog/filter/catalog-filter-type-2.vue'),
    ComponentCategoryPathDropDown: () =>
      import('~/components/navigation/category-path-drop-down.vue'),
    ComponentProductAdditionalWrapper: () =>
      import('~/components/products/product-additional-wrapper.vue'),
    ComponentCatalogSections: () =>
      import('~/components/catalog/category/catalog-sections.vue'),
    LazyHydrate,
  },
  filters: {
    filterAmountProducts(num: number, amount: [string, string, string]) {
      return num.toString() + ' ' + declension(num, amount)
    },
  },
})
// Страница раздела каталога. Возврат из товара к той же карточке —
// в MixinCatalogScrollRestore.
export default class PageCatalog extends mixins(MixinCatalogScrollRestore) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        filterUrl(CATALOG_API + '/' + route.params._slug),
        {
          params: route.query,
        }
      )

      return normalizeCatalogResponse(response)
    } catch (err) {
      error(apiError(err))
    }
  }

  @siteStore.Getter('getOptionsCatalogPageType')
  readonly getOptionsCatalogPageType!: string

  private beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    if (to.name === 'products-_id') {
      this.rememberCatalogForReturn(to, from)
    } else {
      this.forgetCatalogForReturn()
    }

    next()
  }

  private beforeRouteUpdate(_to: Route, _: Route, next: NavigationGuardNext) {
    this.forgetCatalogForReturn()

    next()
  }

  private async getContent(concat: boolean = false) {
    const response = await this.$axios.$get(
      filterUrl(CATALOG_API + '/' + this.$route.params._slug),
      {
        params: this.$route.query,
      }
    )

    const data = normalizeCatalogResponse(response)
    // «Показать ещё»: новая страница товаров дописывается к текущему списку.
    if (concat && this.products && data.products) {
      data.products = {
        ...data.products,
        items: this.products.items.concat(data.products.items),
      }
    }
    Object.assign(this, data)
  }

  private pages = 0
  private amount = 0
  private seoFilters: unknown[] = []
  private categoryPath: any = null
  private filter: ICatalogFilterItem[] | null = null
  private sorting: unknown[] = []
  private productsAdditionalIds: number[] = []
  private seo: any = null

  private styleGrid!: IStyle
  private isLoading = false

  private get showProducts() {
    return (
      this.products && this.products.items && this.products.items.length > 0
    )
  }

  private popularSearches: ICatalogPopularSearches | null = null

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []

  @Watch('meta', {
    immediate: true,
  })
  private metaHandler(val: IMeta) {
    if (val) {
      this.setMeta(val)
    }
  }

  @Watch('breadcrumbs', {
    immediate: true,
  })
  private breadcrumbsHandler(val: IBreadcrumbsItem[]) {
    if (val) {
      this.setBreadcrumbs(val)
    }
  }

  private banners: IBanner[] = []

  private get bannersRenderSidebar() {
    return this.banners.filter((banner) => banner.position === 'sidebar')
  }

  private get bannersRenderMainStart() {
    return this.banners.filter((banner) => banner.position === 'mainStart')
  }

  @Watch('$route')
  private async routeHandler() {
    if (this.$route.query.showMore !== '1') {
      this.isLoading = true
      await this.getContent()
      this.isLoading = false
    }
  }

  private styleSpacer!: IStyle

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.isMobile,
      [this.styleSpacer.mbGutter]: this.isMobile,
    }
  }

  private sections: ICatalogSections | null = null

  private get hasSections() {
    return !!(
      this.sections &&
      this.sections.items &&
      this.sections.items.length
    )
  }

  // Левая колонка на десктопе (type-1): фильтры, дерево категорий,
  // баннеры. В разделе, где только подразделы, ей нечего показывать —
  // тогда без сетки, иначе справа от пустой колонки оставалась дыра.
  private get hasDesktopSidebar() {
    return (
      !this.isMobile &&
      this.getOptionsCatalogPageType === 'type-1' &&
      (this.showProducts ||
        !this.hasSections ||
        this.bannersRenderSidebar.length > 0)
    )
  }

  private get componentNameProducts() {
    return componentNameProducts(this.products, this.isMobile)
  }

  private get classProducts() {
    return {
      [this.$style.products]: true,
      [this.$style.table]: this.products
        ? this.products.type === 'table'
        : false,
      [this.$style.col6]: this.getOptionsCatalogPageType === 'type-2',
    }
  }

  private async showMore() {
    this.isLoading = true

    const query = { ...this.$route.query }
    const currentNum = Number(this.$route.query.page) || 1
    query.page = (currentNum + 1).toString()
    query.showMore = '1'
    await this.$router.replace({
      path: this.$route.path,
      query,
    })
    await this.getContent(true)

    this.isLoading = false
  }
}
